export default () => (input, start) => {
    if (input) {
	   start = +start;
	   return input.slice(start);
    }
    return [];
};
